import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { BookOpen, Clock } from "lucide-react";

export default function MadrasaSection({ content }) {
  const { t, lang } = useLang();
  const info = lang === "ta" ? content?.madrasa_info_ta : content?.madrasa_info_en;
  const fontH = lang === "ta" ? "font-serif-ta" : "font-serif-en";
  const fontB = lang === "ta" ? "font-sans-ta" : "";

  return (
    <section id="madrasa" data-testid="madrasa-section" className="bg-emerald-950 text-stone-100 py-20 md:py-28 relative overflow-hidden">
      <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-emerald-800/40 blur-3xl" />
      <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-amber-700/20 blur-3xl" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <span className="text-xs uppercase tracking-[0.3em] text-amber-300">مدرسة</span>
            <h2 data-testid="madrasa-heading" className={`${fontH} text-4xl md:text-5xl mt-2 text-amber-50`}>
              {t("madrasa_heading")}
            </h2>
            <p className={`mt-6 text-stone-200/90 text-base md:text-lg leading-relaxed max-w-2xl ${fontB}`}>{info}</p>
          </div>
          <div className="lg:col-span-5">
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 backdrop-blur">
              <div className="flex items-center gap-3 mb-4 text-amber-300">
                <Clock className="w-5 h-5" />
                <span className="uppercase text-xs tracking-[0.25em]">{t("madrasa_timings_label")}</span>
              </div>
              <div className="text-lg text-stone-100">{content?.madrasa_timings}</div>
              <div className="mt-6 flex items-center gap-3 text-amber-300">
                <BookOpen className="w-5 h-5" />
                <span className="uppercase text-xs tracking-[0.25em]">Curriculum</span>
              </div>
              <ul className="mt-3 text-stone-200/90 text-sm space-y-1.5 list-disc list-inside">
                <li>Qur'an Recitation &amp; Memorization (Hifz)</li>
                <li>Tajweed &amp; Arabic Language</li>
                <li>Islamic Studies &amp; Hadith</li>
                <li>Moral &amp; Character Development</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
